import React from 'react';
import { Link, useForm } from '@inertiajs/react';
import AuthLayout from '../../components/AuthLayout.jsx';

export default function PasswordResetNew() {
  const { data, setData, post, processing } = useForm({
    email: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    post('/password_resets');
  };

  return (
    <AuthLayout>
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="flex justify-center mb-6">
            <img src="/logo.png" alt="123CEU" className="h-12 w-auto" />
          </div>
          <h2 className="mt-2 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Reset your password</h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">Email</label>
              <input
                id="email"
                type="email"
                required
                autoFocus
                placeholder="Enter your email"
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
            <div className="mt-6">
              <button
                type="submit"
                disabled={processing}
                className="cursor-pointer flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50"
              >
                {processing ? 'Sending...' : 'Send reset link'}
              </button>
            </div>
          </form>

          <p className="mt-6 text-center text-sm/6 text-gray-600">
            <Link href="/login" className="font-semibold text-indigo-600 hover:text-indigo-500">
              Back to login
            </Link>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
}
